import type { BreadcrumbsResources } from '../en/breadcrumbs';

// Keys are the English breadcrumb labels (see en/breadcrumbs.ts); values are
// the German labels.
export const breadcrumbs: BreadcrumbsResources = {
  'Fleet Management': 'Fuhrpark',
  Vehicles: 'Fahrzeuge',
  'Vehicle Detail': 'Fahrzeugdetails',
  'Add Vehicle': 'Fahrzeug hinzufügen',
  Drivers: 'Fahrer',
  'Driver Detail': 'Fahrerdetails',
  'Add Driver': 'Fahrer hinzufügen',
  'Data Sharing': 'Datenfreigabe',
  Developer: 'Entwickler',
  Demo: 'Demo',
  User: 'Benutzer',
  Account: 'Konto',
  Billing: 'Abrechnung',
  Notifications: 'Benachrichtigungen',
  Logout: 'Abmelden',
  Login: 'Anmelden',
  Users: 'Benutzer',
  'User Detail': 'Benutzerdetails',
  'Org Units': 'Organisationseinheiten',
  Locations: 'Standorte',
};
